export const handleCVDownload = async () => {

    // Public URL for CV PDF (ensure this is a direct download link)
    const CV_DOWNLOAD_URL = 'https://drive.google.com/file/d/1EEYgFCTWodp2M02mmmAIfkd3rQkM0e59/view?usp=sharing';
    // Function to extract the file ID from the shareable link
    const extractFileId = (url) => {
        const match = url.match(/[-\w]{25,}/);
        return match ? match[0] : null;
    };

    const fileId = extractFileId(CV_DOWNLOAD_URL);

    if (!fileId) {
        alert("Invalid Google Drive link");
        return;
    }

    // Construct the Google Drive download URL
    const downloadUrl = `https://drive.google.com/uc?export=download&id=${fileId}`;

    try {

        // Create a hidden anchor element to trigger the download
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = "downloaded_file"; // Set default filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

    } catch (error) {
        console.error('Download failed:', error);

        // Fallback method - direct link
        window.open(CV_DOWNLOAD_URL, '_blank');
    }
};